import React from "react";
import { usePageContext } from "vike-react/usePageContext";

import "@/assets/style/navbar.scss";

type NavbarType = "main" | "sub";

interface NavbarItemsProps {
  type?: NavbarType;
}

export default function NavbarItems({ type = "main" }: NavbarItemsProps) {
  const { urlPathname } = usePageContext();

  const getActive = (url: string) => url === urlPathname;

  const navLinks =
    type === "main"
      ? {
        "/platform": "Platform",
        "/solutions": "Solutions",
        "/download": "Download",
        "/contact-us": "Getting Started",
      }
      : {
        "/clinics": "Clinics Near You",
        "/travel-restrictions-and-travel-bans": "Travel Restrictions",
        "https://blog.furtherpass.com/blog/travel-insights-from-furtherpass-blog-1": "Blog",
        "https://blog.furtherpass.com/blog/travel-regulation-update-2": "Travel Regulations",
      };

  return (
    <ul className={`navbar-nav ${type === "main" ? "ms-auto" : ""}`}>
      {Object.entries(navLinks).map(([url, label], index) => {
        const active = getActive(url);
        return (
          <li
            className="nav-item"
            key={url}
            style={{
              "--animation-delay": `${index * 0.1}s`,
            } as React.CSSProperties}
          >
            <a
              className={`nav-link${active ? " active" : ""}`}
              {...(active ? { "aria-current": "page" } : {})}
              href={url}
              target={url.startsWith("http") ? "_blank" : undefined}
              rel={url.startsWith("http") ? "noopener noreferrer" : undefined}
            >
              {label}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
